export default "__VITE_ASSET__002c910a__"